import { FC } from "react";

import ConnectedLayout from "../../components/ConnectedLayout";
import Header from "../../components/Header";

import "./style.css";

const Contact: FC = () => {
    return (
        <ConnectedLayout>
            <Header title="Besoin d’aide ?" />
            <p className="contact_text">
                Contactez Fabrice au{" "}
                <a href="tel:0745086824" target="_blank" rel="noreferrer">
                    07 45 08 68 24
                </a>{" "}
                ou par{" "}
                <a
                    href="mailto:fabrice@objectif-trading.fr"
                    target="_blank"
                    rel="noreferrer"
                >
                    mail.
                </a>
            </p>
        </ConnectedLayout>
    );
};

export default Contact;
